// 获取本地上传的图片文件的url txt文件路径也可以得到
import Router from '@/router';
import crypto from '@/utils/crypto';
import { getPlayerState, launchPlay } from '@/utils/bridge.js';
import { UAParser } from 'ua-parser-js';
export function getFormatTime() {
    let format = 'yyyy-MM-dd hh:mm:ss';
    const nowTime = new Date();
    const args = {
        'M+': nowTime.getMonth() + 1,
        'd+': nowTime.getDate(),
        'h+': nowTime.getHours(),
        'm+': nowTime.getMinutes(),
        's+': nowTime.getSeconds(),
        'q+': Math.floor((nowTime.getMonth() + 3) / 3),
        S: nowTime.getMilliseconds()
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (nowTime.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const i in args) {
        const n = args[i];
        if (new RegExp('(' + i + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? n : ('00' + n).substr(('' + n).length));
        }
    }
    return format;
}
export function uuid() {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
        // @ts-ignore
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    // @ts-ignore
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    // @ts-ignore
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    // @ts-ignore
    s[8] = s[13] = s[18] = s[23] = '';
    const uuid = s.join('');
    const newUuid = '01000f' + uuid.substring(6);
    return newUuid;
}
function detectDeviceType() {
    const ua = navigator.userAgent.toLowerCase();
    // 先判断是否是移动设备
    const isMobile = /mobile|android|iphone|ipad|ipod|windows phone/i.test(ua);
    // 如果不是移动设备，则返回 'pc'
    if (!isMobile) {
        return 'pc';
    }
    // 如果是移动设备，继续检测品牌
    if (/iphone|ipad|ipod|macintosh/.test(ua))
        return 'apple';
    if (/huawei|honor|hnl-|h60-|lnd-|lya-|ane-/.test(ua))
        return 'huawei';
    if (/mi\s|redmi|xiaomi|mi\s\d+[a-z]|2107119dc|2203121c/.test(ua))
        return 'xiaomi';
    if (/oppo|p[cg][t0-9]+|rmx\d+|oneplus|cph\d+/.test(ua))
        return 'oppo';
    if (ua.includes('allsaints'))
        return 'oppo';
    if (/vivo|iqoo|v\d+[a-z]|pd\d+[a-z]/.test(ua))
        return 'vivo';
    if (/samsung|sm-|gt-|galaxy/.test(ua))
        return 'samsung';
    if (/meizu/.test(ua))
        return 'meizu';
    if (/nokia/.test(ua))
        return 'nokia';
    if (/sony|xperia/.test(ua))
        return 'sony';
    if (/google|pixel/.test(ua))
        return 'google';
    if (/htc/.test(ua))
        return 'htc';
    if (/lenovo|moto/.test(ua))
        return 'lenovo';
    // 默认返回 unknown（可能是其他移动设备）
    return 'pc';
}
export function setParament(reqData) {
    const data1 = UAParser(navigator.userAgent);
    console.log(data1, 'setParament');
    // {
    //     "ua": "Mozilla/5.0 (Linux; Android 14; PFTM10 Build/UKQ1.230924.001; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/117.0.0.0 Mobile Safari/537.36 AllSaints_101031430",
    //     "browser": {
    //         "name": "Chrome WebView",
    //         "version": "117.0.0.0",
    //         "major": "117"
    //     },
    //     "cpu": {},
    //     "device": {
    //         "type": "mobile",
    //         "model": "PFTM10"
    //     },
    //     "engine": {
    //         "name": "Blink",
    //         "version": "117.0.0.0"
    //     },
    //     "os": {
    //         "name": "Android",
    //         "version": "14"
    //     }
    // }
    const data = {
        pageId: '',
        pointX: '',
        pointY: '',
        operate: '',
        operateDesc: {},
        account: '',
        phone: '',
        serialNumber: '',
        duration: '',
        dataScource: '',
        channelId: '',
        appVersion: '',
        reserve1: '',
        reserve2: '',
        imeiOrIdfa: '',
        phoneBrand: '',
        phoneType: '',
        accountType: '',
        resolutionX: '',
        resolutionY: '',
        currentUrl: '',
        referUrl: '',
        title: '',
        enterTime: '',
        operateSystem: '',
        UUID: ''
    };
    let vuuid = window.localStorage.getItem('unicomUuid');
    if (!vuuid || vuuid === 'undefined') {
        vuuid = uuid();
        window.localStorage.setItem('unicomUuid', vuuid);
    }
    data.pageId = reqData.pageId || '';
    data.pointX = reqData.pointX || '';
    data.pointY = reqData.pointY || '';
    data.operate = reqData.operate || '';
    data.operateDesc = reqData.operateDesc || {};
    data.account = reqData.account || '';
    data.phone = reqData.phone || '';
    data.serialNumber = reqData.serialNumber || '';
    data.duration = reqData.duration || '';
    data.dataScource = reqData.dataScource || 'BOWAN_H5';
    data.channelId = '3000018828';
    data.appVersion = reqData.appVersion || '';
    data.reserve1 = reqData.reserve1 || '';
    data.reserve2 = reqData.reserve2 || '';
    data.imeiOrIdfa = reqData.imeiOrIdfa || '';
    data.phoneBrand = detectDeviceType() || '';
    data.phoneType = data1.device.model || '';
    data.accountType = reqData.accountType || '';
    data.resolutionX = reqData.resolutionX || (window.screen.availWidth).toString() || '';
    data.resolutionY = reqData.resolutionY || (window.screen.availHeight).toString() || '';
    data.currentUrl = window.location.href || reqData.currentUrl || '';
    data.referUrl = document.referrer || reqData.referUrl || '';
    data.title = document.title || reqData.title || '';
    data.enterTime = getFormatTime();
    data.operateSystem = getOS();
    data.UUID = vuuid;
    console.log(data, 'setParament2');
    return data;
}
export function getObjectURL(file) {
    let url = null;
    if (window.createObjectURL !== undefined) {
        url = window.createObjectURL(file);
    }
    else if (window.URL !== undefined) {
        url = window.URL.createObjectURL(file);
    }
    else if (window.webkitURL !== undefined) {
        url = window.webkitURL.createObjectURL(file);
    }
    return url;
}
// nonce32位随机字符串
export function randomString() {
    /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    const maxPos = $chars.length;
    let randomStr = '';
    for (let i = 0; i < 32; i++) {
        randomStr += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return randomStr;
}
export function getOS() {
    let os;
    if (navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1) {
        os = 'Android';
    }
    else if (navigator.userAgent.indexOf('iPhone') > -1) {
        os = 'iOS';
    }
    else if (navigator.userAgent.indexOf('Windows Phone') > -1) {
        os = 'WP';
    }
    else {
        os = 'Others';
    }
    return os;
}
export function getOSVersion() {
    const OSVision = '';
    return OSVision;
}
export function getObj(obj) {
    const obj1 = {};
    for (const key in obj) {
        // eslint-disable-next-line no-useless-escape
        const n = key.replace(/\-/g, '_');
        obj1[n] = obj[key];
    }
    return obj1;
}
export function getNetType() {
    const type = /NetType/.test(navigator.userAgent) ? navigator.userAgent.match(/NetType\/(\S*)/)?.[1] : '';
    const bool = type === 'WIFI';
    return bool;
}
export function getPhoneType() {
    let model = '';
    const u = navigator.userAgent;
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // Android
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) {
        model = u.split('Build/')[0].substring(u.split('Build/')[0].lastIndexOf(';') + 1);
    }
    if (isIOS) {
        if (u.indexOf('iPhone') > -1) {
            model = 'iPhone';
        }
    }
    return model;
}
// 时间戳转为指定格式时间 Y-M-D h:m:s 、Y年M月D日 h:m:s等
export function formatTimeDate2(format = 'YYYY-MM-DD hh:mm:ss', timestamp = '') {
    if ((timestamp + '').trim() === '' ||
        (timestamp + '').trim() === 'undefined' ||
        (timestamp + '').trim() === 'NaN' ||
        (timestamp + '').trim() === 'null' ||
        (timestamp + '').trim() === 'false' ||
        (timestamp + '').trim() === '0') {
        return '';
    }
    const date = new Date(timestamp);
    const dateInfo = {
        Y: date.getFullYear(),
        M: date.getMonth() + 1,
        D: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds()
    };
    const formatNumber = (n) => (n >= 10 ? n.toString() : '0' + n);
    const res = format
        .replace('YYYY', dateInfo.Y.toString())
        .replace('MM', formatNumber(dateInfo.M))
        .replace('DD', formatNumber(dateInfo.D))
        .replace('hh', formatNumber(dateInfo.h))
        .replace('mm', formatNumber(dateInfo.m))
        .replace('ss', formatNumber(dateInfo.s));
    return res;
}
// 判断数组中是否有某个值，兼容性写法
export function itemIncludes(arr, item) {
    if (arr.includes) {
        return arr.includes(item);
    }
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === item) {
            return true;
        }
    }
    return false;
}
// 解析url参数
export function parseUrlParams(url) {
    // 将URL解析成对象
    const params = {};
    const queryString = url.split('?')[1];
    if (queryString) {
        const pairs = queryString.split('&');
        for (const pair of pairs) {
            let [key, value] = pair.split('=');
            // 处理编码的值
            if (value) {
                value = decodeURIComponent(value.replace(/\+/g, ' '));
                // 如果已经有了这个键，将其转换为数组
                if (Object.prototype.hasOwnProperty.call(params, key)) {
                    if (!Array.isArray(params[key])) {
                        params[key] = [params[key]];
                    }
                    params[key].push(value);
                }
                else {
                    params[key] = value;
                }
            }
            else {
                params[key] = '';
            }
        }
    }
    return params;
}
// 转换成url参数
export function serializeUrlParams(params, unDecode) {
    let queryString = '';
    for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
            const value = params[key];
            if (value) {
                // 如果值是数组，则将每个值都编码并拼接起来
                if (unDecode) {
                    if (Array.isArray(value)) {
                        for (const item of value) {
                            queryString += `${key}=${item}&`;
                        }
                    }
                    else {
                        queryString += `${key}=${value}&`;
                    }
                }
                else {
                    if (Array.isArray(value)) {
                        for (const item of value) {
                            queryString += `${encodeURIComponent(key)}=${encodeURIComponent(item)}&`;
                        }
                    }
                    else {
                        queryString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
                    }
                }
            }
        }
    }
    // 删除最后一个&
    queryString = queryString.slice(0, -1);
    return queryString;
}
// 节流
export function throttle(func, wait, mustRun) {
    let timeout;
    let startTime = new Date();
    return function (...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const curTime = new Date();
        clearTimeout(timeout);
        // 如果达到了规定的触发时间间隔，触发 handler
        if (curTime.getTime() - startTime.getTime() >= mustRun) {
            const result = func.apply(context, args);
            startTime = curTime;
            return result;
            // 没达到触发间隔，重新设定定时器
        }
        else {
            timeout = setTimeout(() => func.apply(context, args), wait);
        }
        return undefined;
    };
}
// 防抖
export function debounce(func, wait, immediate) {
    let timeout;
    let args;
    let result;
    return function (...funcArgs) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        args = funcArgs;
        clearTimeout(timeout);
        if (immediate) {
            const callNow = !timeout;
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
            if (callNow) {
                result = func.apply(context, args);
            }
        }
        else {
            timeout = setTimeout(function () {
                result = func.apply(context, args);
            }, wait);
        }
        return result;
    };
}
/**
 * 判断元素是否在窗口内
 * @param {HTMLElement} el - 需要判断的元素
 * @returns {boolean} 元素是否在窗口内
 */
export function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth));
}
export function deeplinkto(route, query, showTitle) {
    if (!showTitle) {
        const querystr = serializeUrlParams(query, true);
        const url = window.location.origin + '/' + Router.resolve(route).href;
        const dplink = 'allmusic://internalWebPage/url/' + `${url}?${querystr}&show_title=1`;
        window.location.href = dplink;
    }
    else {
        query.header_type = 2;
        const querystr = serializeUrlParams(query, true);
        const url = window.location.origin + '/' + Router.resolve(route).href;
        const dplink = 'allmusic://internalWebPage/url/' + `${url}?${querystr}&show_title=${showTitle}`;
        window.location.href = dplink;
    }
}
export function getFixedRandomNumber(id) {
    // 使用 murmurHash3 哈希函数
    const murmurHash3 = (key) => {
        let remainder = 0;
        let bytes = 0;
        let h1 = 0;
        let h1b = 0;
        let c1 = 0;
        let c2 = 0;
        let k1 = 0;
        let i = 0;
        remainder = key.length & 3;
        bytes = key.length - remainder;
        h1 = 0x85ebca6b;
        c1 = 0xcc9e2d51;
        c2 = 0x1b873593;
        i = 0;
        while (i < bytes) {
            k1 =
                ((key.charCodeAt(i) & 0xff)) |
                    ((key.charCodeAt(++i) & 0xff) << 8) |
                    ((key.charCodeAt(++i) & 0xff) << 16) |
                    ((key.charCodeAt(++i) & 0xff) << 24);
            ++i;
            k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
            k1 = (k1 << 15) | (k1 >>> 17);
            k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;
            h1 ^= k1;
            h1 = (h1 << 13) | (h1 >>> 19);
            h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
            h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
        }
        k1 = 0;
        switch (remainder) {
            case 3:
                k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
                break;
            case 2:
                k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
                break;
            case 1:
                k1 ^= (key.charCodeAt(i) & 0xff);
                k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
                k1 = (k1 << 15) | (k1 >>> 17);
                k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
                h1 ^= k1;
                break;
        }
        h1 ^= key.length;
        h1 ^= h1 >>> 16;
        h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
        h1 ^= h1 >>> 13;
        h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
        h1 ^= h1 >>> 16;
        return h1 >>> 0;
    };
    // 使用哈希函数生成伪随机数
    const hash = murmurHash3(id);
    const randomNumber = hash / 0xffffffff; // 将哈希值映射到 [0, 1) 范围内
    return randomNumber;
}
export function getUidByUrl() {
    const url = decodeURIComponent(window.location.href);
    const queryString = url.split('?')[1] || '';
    const query = {};
    queryString.split('&').forEach((item) => {
        const list = item.split('=');
        if (list.length === 2) {
            query[list[0]] = list[1];
        }
    });
    // eslint-disable-next-line prefer-regex-literals
    const reg = new RegExp('amp;', 'g');
    const $query = JSON.parse(JSON.stringify(query).replace(reg, ''));
    const puidObj = {};
    if ($query.puid) {
        const puid = crypto.byteBase64($query.puid);
        const pudilist = puid.split(',');
        pudilist.forEach((element) => {
            const list = element.split(':') || [];
            if (list.length === 2) {
                puidObj[list[0]] = list[1];
            }
        });
    }
    return puidObj;
}
// 异步插入脚本并在执行完毕后回调
export function loadMiguSdKScript(src, id) {
    return new Promise(function (resolve, reject) {
        const dom = document.getElementById(id);
        if (dom) {
            resolve(true);
        }
        else {
            const script = document.createElement('script');
            script.id = id;
            script.src = src;
            script.onload = () => resolve(true);
            script.onerror = reject;
            document.body.appendChild(script);
        }
    });
}
// 格式化字符串去除括号空格
const BRACKETS_REGEX = /[（(].*?[）)]/g;
export function normalizeSongName(songName) {
    return songName.replace(BRACKETS_REGEX, '').trim().toLowerCase();
}
// 暂停歌曲播放
export function stopPlaySong(openMiniPlayerBar) {
    getPlayerState().then((responseData) => {
        const playData = JSON.parse(responseData);
        let playId = '';
        let playlistId = '';
        if (playData.playState === 1) {
            switch (playData.type) {
                case 1:
                    playId = playData.resourceId;
                    break;
                case 2:
                    playId = isNaN(parseInt(playData.playlistId || '')) ? playData.resourceId : playData.playlistId || '';
                    playlistId = playData.playlistId || '';
                    break;
                case 3:
                    playId = isNaN(parseInt(playData.albumId || '')) ? playData.resourceId : playData.albumId || '';
                    break;
                case 5:
                    playId = isNaN(parseInt(playData.albumId || '')) ? playData.resourceId : playData.albumId || '';
                    playlistId = playData.radioId || '';
                    break;
                case 6:
                    playId = playData.playlistId || '';
                    break;
                default:
                    playId = playData.resourceId;
            }
            launchPlay(playData.type + '', playlistId || playId || playData.resourceId, '', !!openMiniPlayerBar, false, 1, playlistId, '');
        }
    }).catch((err) => {
        console.log(err);
    });
}
// 暂停歌曲播放
export function stopPlaySongPrmoise(openMiniPlayerBar) {
    return new Promise((resolve, reject) => {
        getPlayerState().then((responseData) => {
            const playData = JSON.parse(responseData);
            let playId = '';
            let playlistId = '';
            if (playData.playState === 1) {
                switch (playData.type) {
                    case 1:
                        playId = playData.resourceId;
                        break;
                    case 2:
                        playId = isNaN(parseInt(playData.playlistId || '')) ? playData.resourceId : playData.playlistId || '';
                        playlistId = playData.playlistId || '';
                        break;
                    case 3:
                        playId = isNaN(parseInt(playData.albumId || '')) ? playData.resourceId : playData.albumId || '';
                        break;
                    case 5:
                        playId = isNaN(parseInt(playData.albumId || '')) ? playData.resourceId : playData.albumId || '';
                        playlistId = playData.radioId || '';
                        break;
                    case 6:
                        playId = playData.playlistId || '';
                        break;
                    default:
                        playId = playData.resourceId;
                }
                launchPlay(playData.type + '', playlistId || playId || playData.resourceId, '', !!openMiniPlayerBar, false, 1, playlistId, '');
                resolve();
            }
            else {
                reject(Error('false'));
            }
        }).catch((err) => {
            console.log(err);
            reject(err);
        });
    });
}
